import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

const TableComponent = ({ tableConfig, columns, checkable }) => {
  const {
    headers,
    listData,
    servicesPatientId,
    detailFunction,
    tableHeight = "table-height-10",

    urlNext,
    handleNextPage,
    checkedList,
    setCheckedList,
    initialSort,
    initialDirection,
  } = tableConfig;
  const [data, setData] = useState([]);
  const [currentSort, setCurrentSort] = useState({
    key: null,
    direction: "asc",
  });
  const [allChecked, setAllChecked] = useState(false);

  const sortList = (direction, sortOption, list) => {
    const sortedList = [...list].sort((a, b) => {
      if (a[sortOption] < b[sortOption]) return direction === "asc" ? -1 : 1;
      if (a[sortOption] > b[sortOption]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    return sortedList;
  };
  const handleSort = (sortOption) => {
    if (sortOption) {
      const direction =
        currentSort.key === sortOption && currentSort.direction === "asc"
          ? "desc"
          : "asc";
      const sortedData = sortList(direction, sortOption, data);

      setData(sortedData);
      setCurrentSort({ key: sortOption, direction });
    }
  };
  useEffect(() => {
    let newData = listData || [];

    if (newData.length > 0) {
      let sortOption = initialSort || Object.keys(newData[0])[0];
      const direction = initialDirection || "asc";
      try {
        newData = sortList(direction, sortOption, newData);
      } catch (error) {
        console.error("Error sorting data:", error);
      }
    }
    setData(newData);
  }, [listData]);

  return (
    <div className={`table-container ${tableHeight}`}>
      <table className="table mb-1">
        <thead>
          <tr>
            {checkable && (
              <th>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                    id="flexCheckAll"
                    checked={allChecked}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // If checked, add all item IDs to checkedList
                        const allIds = listData.map((item) => item.id);
                        setCheckedList(allIds);
                        setAllChecked(true);
                      } else {
                        // If unchecked, clear the checkedList
                        setCheckedList([]);
                        setAllChecked(false);
                      }
                    }}
                  />
                </div>
              </th>
            )}
            {Array.isArray(headers) &&
              headers.map((header, i) => {
                return (
                  <th
                    key={i}
                    className={`${header.cName} table-column-header`}
                    onClick={() => handleSort(header.columnName)}
                  >
                    <div className="d-flex justify-content-center">
                      {header.name}
                    </div>
                  </th>
                );
              })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, i) => {
            return (
              <tr key={item.id}>
                {checkable && (
                  <td className="align-middle">
                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        defaultValue
                        type="checkbox"
                        checked={checkedList.includes(item.id)}
                        id="flexCheckDefault"
                        onChange={() => {
                          setCheckedList((prevCheckedList) => {
                            if (prevCheckedList.includes(item.id)) {
                              setAllChecked(false);
                              return prevCheckedList.filter(
                                (id) => id !== item.id
                              );
                            } else {
                              const newList = [...prevCheckedList, item.id];
                              const allAreChecked =
                                newList.length === listData.length;
                              setAllChecked(allAreChecked);
                              return newList;
                            }
                          });
                        }}
                      />
                    </div>
                  </td>
                )}

                {columns?.map((column, i) => (
                  <td key={i} className={`align-middle ${headers[i].cName}`}>
                    <span className="d-flex justify-content-center align-items-center">
                      {item[column]}
                    </span>
                  </td>
                ))}
                {detailFunction && (
                  <td className="align-middle">
                    <div className="d-flex justify-content-center">
                      {servicesPatientId ? (
                        <Button
                          variant="primary gap-2"
                          onClick={() =>
                            detailFunction(servicesPatientId, item.id)
                          }
                        >
                          <i className="bi bi-list-ul" />
                        </Button>
                      ) : (
                        <Button
                          variant="primary gap-2"
                          onClick={() => detailFunction(item.id)}
                        >
                          <i className="bi bi-list-ul" />
                        </Button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {urlNext && (
        <div className="table-footer">
          <Button
            variant="outline-primary"
            className="fw-bolder"
            onClick={handleNextPage}
          >
            Ver más
          </Button>
        </div>
      )}
    </div>
  );
};

export default TableComponent;
